import { gql } from "@apollo/client";

export default gql`
  query searchAiHelp($data: AiHelpSearchInput!){
    searchAiHelp(data: $data){
        success
        data{
            articleId
            slug
            title
            panelPath
            permissions
            contentId
            heading
            text
            images{
                key
                url
                caption
                description
            }
            score
        }
        code
        message
    }
}
`
